import { pipe } from 'ramda';
import { setAction, setLabel } from '@creditas-lab/analytics-events';
import { DispatchEvent, dispatchFrontendDashboardEvent } from './commons';

const dispatchHeaderEvent: DispatchEvent = pipe(
  setAction('header_menu'),
  dispatchFrontendDashboardEvent,
);

const dispatchAtWorkEvent: DispatchEvent = pipe(setLabel('atwork'), dispatchHeaderEvent);

const dispatchDiscoveryEvent: DispatchEvent = pipe(
  setAction('discovery'),
  dispatchFrontendDashboardEvent,
);

const dispatchDiscoveryAtworkEvent: DispatchEvent = pipe(
  setLabel('atwork'),
  dispatchDiscoveryEvent,
);

export { dispatchAtWorkEvent, dispatchDiscoveryAtworkEvent };
